import React from 'react';
import Link from 'next/link';
import Head from "next/head";
import { Button, Col, Container, Row } from 'reactstrap';
import data from '../data/index.json';
import CountriesBlock from '../components/CountriesBlock';
import InsprirationBlock from '../components/InspirationBlock';
import Image from "next/image";
import { getImageUrl, getLargeImageUrl } from "../services/image";
import Icon from "../components/Icon";
import HomePageSearchBar from "../components/HomePageSearchBar";
import LargeScreenComponent from "../components/LargeScreenComponent";
import SmallScreenComponent from "../components/SmallScreenComponent";
import dynamic from "next/dynamic";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ActionBlock = dynamic(function () {
  return import("../components/ActionBlock");
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../components/ActionBlock")];
    },
    modules: ["index.js -> " + "../components/ActionBlock"]
  }
});

var Index = function Index() {
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "Vakantiehuizen Engeland, Schotland, Wales en Ierland | Cottage Centre Vakantiehuizen"
      }), /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: "Op zoek naar een uniek vakantiehuis in Ierland, Engeland, Schotland of Wales? Vind en boek uw vakantiehuis online bij Cottage Centre."
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: "d-flex align-items-center dark-overlay dark-overlay-gradient overflow-none",
      children: [/*#__PURE__*/_jsx(Image, {
        src: "".concat(getLargeImageUrl(data.swiperImages[0])),
        layout: "fill",
        className: "bg-image",
        alt: "Cottage Centre vakantiehuizen",
        priority: true
      }), /*#__PURE__*/_jsxs(Container, {
        className: "py-md-7 mt-4 text-white z-index-20",
        children: [data.hero && /*#__PURE__*/_jsxs("div", {
          className: "text-center text-lg-left",
          children: [/*#__PURE__*/_jsx("p", {
            className: "subtitle subtitle-small letter-spacing-4 mb-2 text-green-light text-shadow d-lg-none",
            children: data.hero.subTitle
          }), /*#__PURE__*/_jsx("p", {
            className: "subtitle letter-spacing-4 mb-2 text-green-light text-shadow d-none d-lg-block",
            children: data.hero.subTitle
          }), /*#__PURE__*/_jsx("h1", {
            className: "font-weight-bold text-shadow homepage-header-h1",
            children: data.hero.title
          })]
        }), /*#__PURE__*/_jsx(HomePageSearchBar, {})]
      })]
    }), data.topBlocks && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LargeScreenComponent, {
        children: /*#__PURE__*/_jsx("section", {
          className: "py-3",
          children: /*#__PURE__*/_jsx(Container, {
            fluid: true,
            children: /*#__PURE__*/_jsx(Row, {
              className: "bg-gray-100",
              children: data.topBlocks.blocks.map(function (block) {
                return /*#__PURE__*/_jsx(Col, {
                  lg: "3",
                  className: "my-3",
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      xs: 2,
                      children: /*#__PURE__*/_jsx("div", {
                        className: "icon-rounded",
                        children: /*#__PURE__*/_jsx(Icon, {
                          icon: block.icon,
                          className: "text-primary w-2rem h-2rem"
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      xs: 10,
                      children: /*#__PURE__*/_jsxs("div", {
                        className: "px-0 px-lg-3 pl-3",
                        children: [/*#__PURE__*/_jsx("h2", {
                          className: "h5",
                          children: block.title
                        }), /*#__PURE__*/_jsx("p", {
                          className: "text-muted dark",
                          children: block.content
                        })]
                      })
                    })]
                  })
                }, block.title);
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(SmallScreenComponent, {
        children: /*#__PURE__*/_jsx("section", {
          className: "py-2 pr-2",
          children: /*#__PURE__*/_jsx(Container, {
            fluid: true,
            children: /*#__PURE__*/_jsx(Row, {
              className: "",
              children: data.topBlocks.blocksMobile.map(function (block) {
                return /*#__PURE__*/_jsx(Col, {
                  xs: "3",
                  className: "text-center p-0",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "",
                    children: /*#__PURE__*/_jsx("span", {
                      className: "mobile-usp ml-1 mr-1 mt-1",
                      children: block.title
                    })
                  })
                }, block.title);
              })
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(ActionBlock, {}), /*#__PURE__*/_jsx("a", {
      "aria-label": "Inspiratie",
      href: "/#inspiratie",
      className: "anchor",
      id: "inspiratie"
    }), /*#__PURE__*/_jsx(InsprirationBlock, {
      title: data.inspiration.title,
      subTitle: data.inspiration.subTitle,
      greyBackground: true
    }), data.countries && /*#__PURE__*/_jsx(CountriesBlock, {
      title: data.countries.title,
      subTitle: data.countries.subTitle
    }), data.jumbotron && /*#__PURE__*/_jsxs("section", {
      className: "py-12 position-relative dark-overlay",
      children: [/*#__PURE__*/_jsx(Image, {
        src: getImageUrl(data.jumbotron.img),
        alt: "",
        layout: "fill",
        objectFit: "cover",
        className: "bg-image"
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "overlay-content text-white py-lg-5",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "display-4 font-weight-bold text-serif text-shadow mb-5",
            children: data.jumbotron.title
          }), /*#__PURE__*/_jsx(Link, {
            href: data.jumbotron.link,
            children: /*#__PURE__*/_jsx(Button, {
              color: "light",
              children: data.jumbotron.button
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: "py-6",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "py-4",
          children: [/*#__PURE__*/_jsx("h1", {
            children: "Vakantiehuizen Groot-Brittanni\xEB en Ierland"
          }), /*#__PURE__*/_jsx("p", {
            className: "mb-5 subtitle text-primary",
            children: "Wij selecteren de mooiste cottages, u maakt de mooiste herinneringen"
          }), /*#__PURE__*/_jsx(Row, {
            className: "mb-5",
            children: /*#__PURE__*/_jsx(Col, {
              md: "12",
              children: "Groot-Brittanni\xEB & Ierland hebben zo ontzettend veel moois te bieden voor iedereen die van natuur, cultuur en avontuur houdt. Er is werkelijk voor ieder wat wils en iedereen zou dit moeten ervaren. Vanuit deze gedachte is ruim 15 jaar geleden Cottage Centre gestart. Cottage Centre bemiddelt in de verhuur van vakantiehuizen in alle gebieden van Ierland, Engeland, Schotland en Wales en we werken hiervoor samen met veel lokale partijen en eigenaren."
            })
          }), /*#__PURE__*/_jsxs(Row, {
            className: "mb-5",
            children: [/*#__PURE__*/_jsx(Col, {
              md: "6",
              children: /*#__PURE__*/_jsxs(React.Fragment, {
                children: [/*#__PURE__*/_jsx("h2", {
                  children: "Onze vakantiehuizen"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-muted dark mb-4",
                  children: "Onze vakantiehuizen zijn met zorg gekozen met oog voor ligging, onderhoud en uitstraling. Door de jarenlange ervaring kunnen wij u als klant een vakkundig advies bieden bij het kiezen van het ideale vakantiehuis. Of dit nu een knusse cottage voor 2, een typisch Engelse cottage in een havenstadje, een vakantiehuis aan zee of een afgelegen vuurtoren langs de kust is, wij helpen u graag op weg! Ga heerlijk genieten met uw familie of vrienden van de ruige natuur in Schotland, gezellige haventjes en pubs in Engeland, mooie kusten van Ierland en diversiteit van Wales. Ga er eens even heerlijk tussenuit en deze prachtige landen vanuit uw eigen vakantiehuis verkennen."
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-muted dark mb-4",
                  children: "Met grote regelmaat worden nieuwe cottages toegevoegd aan onze collectie. Mocht u op zoek zijn naar iets speciaals dat u op de website niet kunt vinden, laat het ons weten en wij vinden het voor u. Een bijzondere locatie voor een bruiloft bijvoorbeeld of een groepslocatie voor een bedrijfsuitje. Neem hierover gerust contact op."
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              md: "6",
              children: /*#__PURE__*/_jsxs(React.Fragment, {
                children: [/*#__PURE__*/_jsx("h2", {
                  children: "Camperverhuur"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-muted dark mb-4",
                  children: "Naast de prachtigste cottages, kunt u bij ons ook campers huren. We bieden u de perfecte camper voor een roadtrip voor 2 personen tot aan een prachtig ingerichte gezinscamper voor maximaal 7 personen. Reis op eigen tempo door valleien, langs de kust, door National Parks en word wakker met de meest fantastische uitzichten. Ervaar een gevoel van vrijheid en flexibiliteit en heb altijd al uw spullen bij de hand om te kunnen koken en uit te rusten. Ga waar u wilt - blijf waar u wilt!"
                }), /*#__PURE__*/_jsx("h2", {
                  children: "Overtochten, toegangspassen en verzekeringen"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-muted dark mb-4",
                  children: "Naast vakantiehuizen verzorgen wij uw (ferry)overtochten naar Schotland, Ierland en Engeland. Hiervoor werken wij al jaren met een vaste partner. Vergeet ook niet direct uw reis- en/of annuleringsverzekering te regelen. En tickets voor attracties, landkaarten, boeken en meer. Wij sturen u graag volledig verzorgd op reis."
                })]
              })
            })]
          }), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              md: "12",
              children: /*#__PURE__*/_jsx("p", {
                className: "subtitle text-primary",
                children: "Cottage Centre is een agentschap waar uw vakantie serieus genomen wordt en kwaliteit vanzelfsprekend is."
              })
            })
          })]
        })
      })
    })]
  });
};

export var __N_SSG = true;
export default Index;